import { Form, Input } from "antd"
import { ButtonPrimary } from "components/ui/buttons/ButtonPrimary/ButtonPrimary"
import { useLogin } from "hooks/api/auth/auth.hook"
import { H2 } from "components/ui/typography/titles/Titles"
import { AxiosError } from "axios"
import { useMessage } from "hooks/message.hook"
import { useAuth } from "hooks/api/auth/auth.hook"
import style from "./FormAuth.module.scss"
import { CustomNavLink } from "components/ui/CustomNavLink/CustomNavLink"
import { AuthProvider } from "components/providers/Forms.provider"

const { formAuth, title, button, forgotPasswordLink } = style

export const FormAuth = () => {
	const [form] = Form.useForm()

	const { setToken } = useAuth()
	const { mutate: loginMutation } = useLogin()
	const { error, success } = useMessage()

	const submitFormHandle = async () => {
		// Validate form fields before making an API request
		const values = await form.validateFields()

		// Perform login request if validation passes
		loginMutation(values, {
			onSuccess: (data) => {
				setToken(data?.data.auth_token)
				success("You are logged in")
			},
			onError: (e) => {
				if (e instanceof AxiosError) {
					const status = e.response?.status
					if (status === 400) {
						error("Unable to log in with provided credentials")
					} else {
						error("Something went wrong, please try again later")
					}
				}
			},
		})
	}

	return (
		<div className={formAuth} data-testid="FormAuth">
			<H2 className={title}>Welcome back!</H2>
			<AuthProvider>
				<Form form={form} onFinish={submitFormHandle} size="large">
					<Form.Item name="email" rules={[{ required: true, type: "email" }]}>
						<Input placeholder="Email" />
					</Form.Item>
					<Form.Item name="password" rules={[{ required: true }]}>
						<Input.Password placeholder="Password" />
					</Form.Item>
					<ButtonPrimary className={button}>Log in</ButtonPrimary>
				</Form>
			</AuthProvider>
			<CustomNavLink className={forgotPasswordLink} to="forgot-password">
				Forgot your password?
			</CustomNavLink>
		</div>
	)
}
